import React, { useState } from 'react'
import "./NavBar.css"
import { Link } from 'react-router-dom';

const NavBar = () => {
      const [isNavExpanded, setIsNavExpanded] = useState(false);
  return (
        <nav className="navbar">
          <div className="nav-logo">
            <Link to="/">
              <img src="/images/logo.jpg" alt="KIGA Logo" />
            </Link>
          </div>
          
          <div className="nav-links">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/classes">Classes</Link>
            <Link to="/portal/booking">Booking</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/news">News</Link>
            <Link to="/contact">Contact</Link>
          </div>
          
          <div className="nav-portal">
            <a href="https://portal-kigaltd.onrender.com" className="portal-btn">Members Portal</a>
          </div>

          <button 
            className="hamburger-btn"
            onClick={() => setIsNavExpanded(!isNavExpanded)}
            aria-label="Toggle menu"
          >
            <svg viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z" clipRule="evenodd" />
            </svg>
          </button>

          <div className={`mobile-menu ${isNavExpanded ? 'open' : ''}`}>
            <button className="close-menu" onClick={() => setIsNavExpanded(false)}>✕</button>
            <ul>
              <li><Link to="/" onClick={() => setIsNavExpanded(false)}>Home</Link></li>
              <li><Link to="/about" onClick={() => setIsNavExpanded(false)}>About</Link></li>
              <li><Link to="/classes" onClick={() => setIsNavExpanded(false)}>Classes</Link></li>
              <li><Link to="/gallery" onClick={() => setIsNavExpanded(false)}>Gallery</Link></li>
              <li><Link to="/register" onClick={() => setIsNavExpanded(false)}>Booking</Link></li>
              <li><Link to="/contact" onClick={() => setIsNavExpanded(false)}>Contact</Link></li>
              <li><Link to="/login" onClick={() => setIsNavExpanded(false)}>Members</Link></li>
            </ul>
          </div>
        </nav>
  )
}

export default NavBar